import { DatePipe } from '@angular/common';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';

import { environment } from '../environments/environment';
import { BreadcrumbsService } from './core/services/breadcrumbs/breadcrumbs.service';
import { LanguageService } from './core/services/language/language.service';
import { MasqueradeService } from './core/services/masquerade/masquerade.service';
import { StorageService } from './core/services/storage/storage.service';
import { UserService } from './core/services/user/user.service';
import { StorageToken } from './shared/configs/storage-token.config';
import { SocketService } from './socket.service';

import { Subscription } from 'rxjs';

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'DD/MM/YYYY',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    DatePipe,
  ],
})
export class AppComponent implements OnInit, OnDestroy {
  toastPosition: string;
  defaultLanguage = 'en';
  private messageSub: Subscription | null = null;

  private tabKey = 'app_tab_lock';
  private tabId = Date.now().toString();
  isDuplicateTab = false;

  constructor(
    public breadcrumbsService: BreadcrumbsService,
    private masqueradeService: MasqueradeService,
    private storageService: StorageService,
    private languageService: LanguageService,
    private socketService: SocketService,
    private userService: UserService
  ) {
    this.toastPosition = `${environment.toast.verticalPosition}-${environment.toast.horizontalPosition}`;
    this.languageService.setDefaultLanguage(this.defaultLanguage);

    if (this.masqueradeService.isMasqueraded()) {
      const masAccessToken = this.storageService.getCookie(StorageToken.masAccessToken);
      this.masqueradeService.setAccessToken(masAccessToken);
    }
  }

  ngOnInit(): void {
    const userData = this.userService.userDetails;
    const username = userData?.preferred_username;

    if (username) {
      this.socketService.connect(username.toString().toLowerCase());
    } else {
      console.warn('User email is undefined. WebSocket not connected.');
    }


      const existingTab = localStorage.getItem(this.tabKey);

      // If already locked, this must be a duplicate tab
      if (existingTab && existingTab !== this.tabId) {
        this.isDuplicateTab = true;
      } else {
        // First tab: set lock
        localStorage.setItem(this.tabKey, this.tabId);
        this.isDuplicateTab = false;
      }

      window.addEventListener('storage', this.storageListener);
      window.addEventListener('beforeunload', () => this.releaseLock());
  }

  ngOnDestroy(): void {
    this.messageSub?.unsubscribe();
    // this.socketService.disconnect();

    this.releaseLock();
    window.removeEventListener('storage', this.storageListener);
  }


  private storageListener = (event: StorageEvent) => {
    if (event.key === this.tabKey) {
      // If another tab set a new lock, this tab should just show warning
      if (event.newValue && event.newValue !== this.tabId) {
        this.isDuplicateTab = true;
      }
    }
  };

  private releaseLock() {
    const lock = localStorage.getItem(this.tabKey);
    if (lock === this.tabId) {
      localStorage.removeItem(this.tabKey);
    }
  }
}
